export * from './events.service';


// WEBPACK FOOTER //
// /Desenvolvimento/PMP/painel/src/app/services/events/index.ts